import React from "react";
import NavBar from "./NavBar"
import Footer from "./Footer"
import origin from "../img/icone/origini.png"
import box from "../img/icone/box.png"
import orologio from "../img/icone/orologio.png"
import qualità from "../img/icone/qualità.png"
import cellulare from "../img/icone/cellulare.png"
import altro from "../img/icone/altro.png"
import { Link } from "react-router-dom";
import { useEffect } from "react";

export default function Info(){

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
       
    let prevScrollpos = window.scrollY;
    window.onscroll = function() {
            
        let currentScrollPos = window.scrollY;
        if (prevScrollpos > currentScrollPos) {
            try {
                document.getElementById("navbar").style.top = "0";
            } catch (error) {
                console.log("helo")
            }
            
        } else {
            try {
                document.getElementById("navbar").style.top = "-60px";
            } catch (error) {
                console.log("helo")
            }
            
        }
        prevScrollpos = currentScrollPos;
    }

    return (
        <div className="informazioniBody wuXieKeJi">
        <NavBar uno ="Contattaci" due="Prodotti" tre="Catalogo" one="/contattaci" two="/prodotti" three="/catalogo"/>       
        <div className="contenitoreContenitore">
            <h2 className="titoloInfo" style={{marginTop:"1rem"}}>INFORMAZIONI</h2>
            <div className="contenitoreFlexInfo">
                <div className="figlioInfo">
                    <img src={origin} alt="img" className="immagineInfo"/>
                    <h3 className="testo titoloPiccolo">Origini</h3>
                    <p className="testo">Questo è un modesto negozio in centro Verona aperto nel 2000.<br/> Con un servizio personalizzato e un impegno alla qualità, nel corso degli anni abbiamo instaurato rapporti duraturi con i clienti.  </p>
                </div>
                <div className="figlioInfo">
                    <img src={box} alt="img" className="immagineInfo"/>
                    <h3 className="testo titoloPiccolo">Prodotti</h3>
                    <p className="testo">Anche se lo spazio fisico disponibile è limitato, la vasta gamma di prodotti disponibili è di certo impressionante: <br/>Orologi, braccialetti, collane, anelli, piercing, ciabatte, cappelli, valigie, borse, zaini, cavo di ricarica per i telefono, cover, vetro protettivo, cuffie, etc..  </p>
                </div>
                <div className="figlioInfo">
                    <img src={qualità} alt="img" className="immagineInfo"/>
                    <h3 className="testo titoloPiccolo">Qualità</h3>
                    <p className="testo">Nonostante la grande mole di prodotti in vendita, cerchiamo sempre di garantire il funzionamento degli articoli. In caso di prodotti guasti o difettosi il personale garantisce la sostituzione o la riparazione di essi. <br /> In caso di altre domande o chiarimenti potete <Link to="/contattaci" style={{fontWeight:"600", color:"Blue"}}>contattarci</Link>. Vi risponderemo al più presto alla vostra email fornita.</p>
                </div>
            </div>
            
        </div>
        <div className="contenitoreContenitore contenitoreContenitoreSotto">
            <h2 className="titoloInfo">SERVIZI</h2>
            <div className="contenitoreFlexInfo">
                <div className="figlioInfo">
                    <img src={orologio} alt="img" className="immagineInfo"/>
                    <h3 className="testo titoloPiccolo">Orologi</h3>
                    <p className="testo">Siamo capaci di cambiare la batteria degli orologi o sostituirne il cinturino. Inoltre sotto richiesta del cliente possiamo accorciare o allungare l'orologio di qualche maglia, cambiare il vetro rotto o graffiato e sostituire il movimento se l'orologio è guasto.</p>
                </div>
                <div className="figlioInfo">
                    <img src={cellulare} alt="img" className="immagineInfo"/>
                    <h3 className="testo titoloPiccolo">Cellulari</h3>
                    <p className="testo">Applichiamo il vetro protettivo ai telefoni in modo perfetto.<br /> Vendiamo una grande quantità di cover protettivi di ogni colore e modello, se la custodia non si adatta perfettamente al telefono c'è la possibilità di fare qualche ritocco per farcelo stare bene.  </p>
                </div>
                <div className="figlioInfo">
                    <img src={altro} alt="img" className="immagineInfo"/>
                    <h3 className="testo titoloPiccolo">Altro...</h3>
                    <p className="testo">Sostituiamo batterie del telecomando per la macchina e altri dispositivi elettronici.<br />Accorciarmo e/o facciamo dei buchi a cinture di pelle. </p>
                </div>
            </div>
            
        </div>
        <Footer />
        </div>
    )
}